import FacebookDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/Facebook.png';
import InstagramDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/Instagram.svg';
import LinkedinDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/LinkedIn.svg';
import PinterestDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/Pinterest.svg';
import DribbleDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/Dribbble.svg';
import BehanceDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/Behance.svg';
import TelegramDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/Telegram.svg';
import YouTubeDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/YouTube.svg';
import TikTokDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/TikTok.svg';
import SpotifyDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/Spotify.svg';
import SnapchatDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/Snapchat.svg';
import AnghamiDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/Anghami.svg';
import TwitchDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/Twitch.svg';
import TwitterDefaultTrans from './../assets/images/SocialIconsDefaultTransparent/Twitter.svg';

// Default icons
import FacebookDefault from './../assets/images/SocialIconsDefault/facebookDefault.svg';
import InstagramDefault from './../assets/images/SocialIconsDefault/instagramDefault.svg';
import LinkedinDefault from './../assets/images/SocialIconsDefault/linkedinDefault.svg';
import PinterestDefault from './../assets/images/SocialIconsDefault/pinterestDefault.svg';
import DribbleDefault from './../assets/images/SocialIconsDefault/dribbleDefault.svg';
import BehanceDefault from './../assets/images/SocialIconsDefault/behanceDefault.svg';
import TelegramDefault from './../assets/images/SocialIconsDefault/telegramDefault.svg';
import YouTubeDefault from './../assets/images/SocialIconsDefault/youtubeDefault.svg';
import TikTokDefault from './../assets/images/SocialIconsDefault/tiktokDefault.svg';
import SpotifyDefault from './../assets/images/SocialIconsDefault/spotifyDefault.svg';
import SnapchatDefault from './../assets/images/SocialIconsDefault/snapchatDefault.svg';
import AnghamiDefault from './../assets/images/SocialIconsDefault/anghamiDefault.svg';
import TwitchDefault from './../assets/images/SocialIconsDefault/twitchDefault.svg';
import TwitterDefault from './../assets/images/SocialIconsDefault/twitterDefault.svg';

export const socialMediaLinks = [
    {
      key: 'facebook',
      name: 'Facebook',
      defaultIconTransparent: FacebookDefaultTrans,
      placeholder: 'fb_url_placeholder',
      linkTemplates: ['facebook.com', 'facebook.net', 'fb.com', 'fb.gg', 'fb.watch'],
    },
    {
      key: 'instagram',
      name: 'Instagram',
      defaultIconTransparent: InstagramDefaultTrans,
      placeholder: 'insta_username_placeholder',
      linkTemplates: ['instagram.com', 'ig.me'],
    },
    {
      key: 'linkedin',
      name: 'Linkedin',
      defaultIconTransparent: LinkedinDefaultTrans,
      placeholder: 'linkedin_url_plcaheolder',
      linkTemplates: ['linkedin.com/in'],
    },
    {
      key: 'pinterest',
      name: 'Pinterest',
      defaultIconTransparent: PinterestDefaultTrans,
      placeholder: 'pinterest_placeholder',
      linkTemplates: ['pinterest.com'],
    },
    {
      key: 'dribbble',
      name: 'Dribbble',
      defaultIconTransparent: DribbleDefaultTrans,
      placeholder: 'dribble_placeholder',
      linkTemplates: ['dribbble.com'],
    },
    {
      key: 'behance',
      name: 'Behance',
      defaultIconTransparent: BehanceDefaultTrans,
      placeholder: 'behance_placeholder',
      linkTemplates: ['behance.net'],
    },
    {
      key: 'telegram',
      name: 'Telegram',
      defaultIconTransparent: TelegramDefaultTrans,
      placeholder: 'telegram_placeholder',
      linkTemplates: ['telegram.me', 't.me', 'telegram.org'],
    },
    {
      key: 'twitter',
      name: 'Twitter',
      defaultIconTransparent: TwitterDefaultTrans,
      placeholder: 'twitter_username_placeholder',
      linkTemplates: ['twitter.com', 'twttr.com', 'twitter.co'],
    },
    {
      key: 'tiktok',
      name: 'Tik Tok',
      defaultIconTransparent: TikTokDefaultTrans,
      placeholder: 'tiktok_placeholder',
      linkTemplates: ['tiktok.com', 'tiktokv.com'],
    },
    {
      key: 'spotify',
      name: 'Spotify',
      defaultIconTransparent: SpotifyDefaultTrans,
      placeholder: 'spotify_url_placeholder',
      linkTemplates: ['open.spotify.com/artist', 'spoti.fi', 'spotify.com'],
    },
    {
      key: 'youtube',
      name: 'YouTube',
      defaultIconTransparent: YouTubeDefaultTrans,
      placeholder: 'yt_url_placeholder',
      linkTemplates: ['youtube', 'youtu.be', 'youtubekids.com', 'yt.be'],
    },
    {
      key: 'snapchat',
      name: 'Snapchat',
      defaultIconTransparent: SnapchatDefaultTrans,
      placeholder: 'snapchat_placeholder',
      linkTemplates: ['story.snapchat.com', 'snapchat.com/add'],
    },
    {
      key: 'anghami',
      name: 'Anghami',
      defaultIconTransparent: AnghamiDefaultTrans,
      placeholder: 'anghami_placeholder',
      linkTemplates: ['play.anghami.com'],
    },
    {
      key: 'twitch',
      name: 'Twitch',
      defaultIconTransparent: TwitchDefaultTrans,
      placeholder: 'twitch_placeholder',
      linkTemplates: ['twitch.tv'],
    },
  ];

  export const ExploreModalData = [
    {
      key: 'instagram',
      name: 'Instagram',
      defaultIcon: InstagramDefault,
      subTitle: 'add_your_profile_brands_profile_or_a_post_you_love',
    },
    {
      key: 'youtube',
      name: 'YouTube',
      defaultIcon: YouTubeDefault,
      subTitle: 'add_your_channel_or_link_to_a_video',
    },
    {
      key: 'tiktok',
      name: 'Tik Tok',
      defaultIcon: TikTokDefault,
      subTitle: 'add_your_profile_or_a_post_you_love',
    },
    {
      key: 'snapchat',
      name: 'Snapchat',
      defaultIcon: SnapchatDefault,
      subTitle: 'add_your_snap_account_or_show',
    },
    {
      key: 'facebook',
      name: 'Facebook',
      defaultIcon: FacebookDefault,
      subTitle: 'add_your_Facebook_page_profile_or_group',
    },
    {
      key: 'twitter',
      name: 'Twitter',
      defaultIcon: TwitterDefault,
      subTitle: 'add_your_profile_or_a_tweet_you_love',
    },
    {
      key: 'spotify',
      name: 'Spotify',
      defaultIcon: SpotifyDefault,
      subTitle: 'add_your_profile_song_or_favourite_playlist',
    },
    {
      key: 'telegram',
      name: 'Telegram',
      defaultIcon: TelegramDefault,
      subTitle: 'share_your_direct_profile',
    },
    {
      key: 'linkedin',
      name: 'Linkedin',
      defaultIcon: LinkedinDefault,
      subTitle: 'share_your_profile_or_companies_page',
    },
    {
      key: 'pinterest',
      name: 'Pinterest',
      defaultIcon: PinterestDefault,
      subTitle: 'Showcase pins, boards and more',
    },
    {
      key: 'dribbble',
      name: 'Dribbble',
      defaultIcon: DribbleDefault,
      subTitle: 'Quick links to your social media accounts',
    },
    {
      key: 'behance',
      name: 'Behance',
      defaultIcon: BehanceDefault,
      subTitle: 'Quick links to your social media accounts',
    },
    {
      key: 'anghami',
      name: 'Anghami',
      defaultIcon: AnghamiDefault,
      subTitle: 'Quick links to your social media accounts',
    },
    {
      key: 'twitch',
      name: 'Twitch',
      defaultIcon: TwitchDefault,
      subTitle: 'Quick links to your social media accounts',
    },
  ];

  export const RatesModalData = [
    {
      key: 'instagram',
      name: 'Instagram',
      defaultIcon: InstagramDefault,
      subTitle: 'add_your_profile_brands_profile_or_a_post_you_love',
    },
    {
      key: 'twitter',
      name: 'Twitter',
      defaultIcon: TwitterDefault,
      subTitle: 'share_your_direct_profile',
    },
    {
      key: 'youtube',
      name: 'YouTube',
      defaultIcon: YouTubeDefault,
      subTitle: 'add_your_channel_or_link_to_a_video',
    },
    {
      key: 'tiktok',
      name: 'Tik Tok',
      defaultIcon: TikTokDefault,
      subTitle: 'add_your_profile_or_a_post_you_love',
    },
    {
      key: 'snapchat',
      name: 'Snapchat',
      defaultIcon: SnapchatDefault,
      subTitle: 'add_your_snap_account_or_show',
    },
    {
      key: 'linkedin',
      name: 'LinkedIn',
      defaultIcon: LinkedinDefault,
      subTitle: 'add_your_profile_or_a_post_you_love',
    },
  ];

  export const monetizeImageMap: any = {
    'instagram': InstagramDefault,
    'youtube': YouTubeDefault,
    'tiktok': TikTokDefault,
    'snapchat': SnapchatDefault,
    'facebook': FacebookDefault,
    'twitter': TwitterDefault,
    'spotify': SpotifyDefault,
    'telegram': TelegramDefault,
    'linkedin': LinkedinDefault,
    'pinterest': PinterestDefault,
    'dribbble': DribbleDefault,
    'behance': BehanceDefault,
    'anghami': AnghamiDefault,
    'twitch': TwitchDefault,
  };

  export const iconsMap: any = {
    'instagram': InstagramDefault,
    'youtube': YouTubeDefault,
    'tiktok': TikTokDefault,
    'snapchat': SnapchatDefault,
    'facebook': FacebookDefault,
    'twitter': TwitterDefault,
    'spotify': SpotifyDefault,
    'telegram': TelegramDefault,
    'linkedin': LinkedinDefault,
    'pinterest': PinterestDefault,
    'dribbble': DribbleDefault,
    'behance': BehanceDefault,
    'anghami': AnghamiDefault,
    'twitch': TwitchDefault,
  };
